import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";


type TitleActions = {
    onPress?:()=>void,
    text?: string,
}

type TitleDataState = {
    titleActions: TitleActions
    titleText: string,
    titleBack: boolean
    setTitleActions: (state: TitleActions, delay?: number) => void;
    setTitleText: (state: string) => void;
    setTitleBack: (state: boolean, delay?: number) => void;
}

export const useTitleDataStore = create<TitleDataState>(
        (set) => ({
            titleActions: {},
            titleBack: false,
            titleText: "",
            setTitleActions: (state, delay = 100) => {
                setTimeout(()=>{
                    set(_ => {
                        return { titleActions: {onPress: state.onPress, text: state.text}  }
                    })
                }, delay);
            },
            setTitleText: (state) => {
                set(_ => {
                    return { titleText: state }
                })
            },
            setTitleBack: (state, delay = 100) => {
                setTimeout(()=>{
                    set(_ => {
                        return { titleBack: state }
                    })
                }, delay);
            }
        })
)
